import { Provider as JotaiProvider } from 'jotai';
import { useAtomsDevtools } from 'jotai-devtools';
import { useEffect } from 'react';
import './App.css';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes/root';
import marketingApplicationStore from './store/markettingContentGeneration';
import BackgroundTaskManager from './components/widgets/BackGroundTaskManager';
import JotaiDebugHooks from './components/widgets/JotaiDebugHooks';

const shouldShowDebugger = import.meta.env.MODE === 'development';

function AppContent() {
  useAtomsDevtools('MyApp');

  useEffect(() => {
    // Force DevTools refresh after component mount
    if (shouldShowDebugger) {
      setTimeout(() => {
        // Trigger a re-render of DevTools
        window.dispatchEvent(new Event('jotai-devtools-refresh'));
      }, 1000);
    }
  }, []);

  return (
    <>
      {shouldShowDebugger && <JotaiDebugHooks />}
      <RouterProvider router={router} />
      <BackgroundTaskManager />
    </>
  );
}

function App() {
  return (
    <JotaiProvider store={marketingApplicationStore}>
      <AppContent />
    </JotaiProvider>
  );
}

App.displayName = 'App';
export default App;
